import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Calendar } from "primereact/calendar";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";
import { getDatesProduccion } from "../../../../Base/Services/Moment/Luxon";

import { InformacionCalendarioMensual } from "../../../../utils/Funciones/FuncionesCalendario"; 

// ------------------ CONSULTAS A LA API --------------------------
import { eliminarTomaInv, getTomaInventarioFechas, getTomaInventarioMPFechas } from "../../../../API/Suministros/Inventario/InventarioRequest";
import ReporteTomaInventario from "./ReporteTomaInventario";


const TomaInventarioScreen = ({IdTipoIngreso = 1}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [dates, setDates] = useState([new Date(), new Date()])
  const [fechaReporte, setFechaReporte] = useState(new Date())
  const [data, setData] = useState([])
  const [mes, setMes] = useState(0);
  const [meses, setMeses] = useState([]);
  const [month, setMonth] = useState(0)
  const [year, setYear] = useState(0);
  const [dialogReporte, setDialogReporte] = useState(false);


  const getInfo = async () => {
    setLoading(true);
    setSelectedDetalle([]);
    const fechas = getDatesProduccion(dates);
    if(dates[0] && dates[1]){
      let dataTempo = [];
      if(IdTipoIngreso === 1){
        dataTempo = await getTomaInventarioFechas(fechas)
      }else{
        dataTempo = await getTomaInventarioMPFechas(fechas)
      }
      setData(dataTempo)
    }
    setLoading(false);
  };

  const obtenerCalendarioOperativo = async () => {
    const calendarioMeses = await InformacionCalendarioMensual();
    setMeses(calendarioMeses);
    let year = new Date().getFullYear();
    let mes = new Date().getMonth() + 1;

    let a = calendarioMeses.filter(
      (e) => mes === e.MesNumero && year === e.Anio
    );
    let mesAnterior = new Date().getMonth();
    let b = calendarioMeses.filter(
      (e) => mesAnterior === e.MesNumero && year === e.Anio
    );
    setYear(year);
    setMonth(mes);

    setMes(a[0].IdMes);
    getInfo(mes, year);
    setMeses(calendarioMeses);
  };

  const filtrarMeses = async (Mes) => {
    setLoading(true);
    setMes(Mes);
    let mesSeleccionado = meses.filter((e) => Mes === e.IdMes);
    let mes = mesSeleccionado[0].MesNumero;
    let year = mesSeleccionado[0].Anio;
    setYear(year);
    setMonth(mes);
    getInfo(mes, year);

    setLoading(false);
  };

  const eliminarTomas = async () => {

    if(selectedDetalle.length === 0){
      toastShow( toast, "warn", "Advertencia", "Seleccione al menos un detalle");
      return
    }

    confirmDialog({
      message: "Esta seguro que desea eliminar",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: async () => {

        setLoading(true)
        selectedDetalle.forEach(async(det) => {

          const detalleActualizado = { 
            ...det, 
            IdUserCancela: userAuth?.IdUser 
          };
          const resp = await eliminarTomaInv(detalleActualizado)
        })

        setTimeout(() => {
          toastShow( toast, "success", "Eliminado", "Detalle eliminado correctamente.");
          obtenerCalendarioOperativo()
          setLoading(false)
        }, 700);




      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
 
  }

  const columns = [
    {
      field: "IdInventario",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Código",
      handerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall",
      Sumary: "count",
      Format: "Modal",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Producto",
      handerEn: "Product",
      field: "NombreProducto",
      className: "Xlarge",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Descripción",
      handerEn: "Description",
      field: "DescripcionProducto",
      className: "XXlarge",
      flex: 1,
      minWidth: 300,
    },
    {
      header: "TipoProducto",
      handerEn: "Product Type",
      field: "NombreCategoria",
      className: "Xsmall",
    },
    {
      header: "Categoría",
      handerEn: "Category",
      field: "NombreSubcategoria",
      className: "Xsmall",
    },
    {
      header: "SubCategoría",
      handerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      header: "Unidad",
      handerEn: "Unit",
      field: "UnitName",
      className: "Xsmall",
    },
    {
      headerName: 'Inventario',
      headerNameEn: 'Inventory',
      children: [           
        {
          header: "Sistema",
          handerEn: "Sistema",
          field: "InventarioSistame",
          className: "Xsmall",
          Format: 'Currency',
          Sumary: 'sum',
          Frozen: true,
          alignFrozen: "right",
        },
        {
          header: "Físico",
          handerEn: "Físico",
          field: "Inventario",
          className: "Xsmall",
          Format: 'Currency',
          Sumary: 'sum',
          Frozen: true,
          alignFrozen: "right",
        },
        {
          header: "Balance",
          handerEn: "Balance",
          field: "Balance",
          className: "Xsmall",
          Format: 'Currency',
          Sumary: 'sum',
          Frozen: true,
          alignFrozen: "right",
        },
      ]
    },
  ];


  const tableHistorico = {
    Columns: columns,
    Data: data,
    // loading: loading,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "TomaInventario", config.language));
  }, []);

  useEffect(() => {
    let mesSeleccionado = meses.filter((e) => mes === e.IdMes);
    if (mes !== 0) {
      filtrarMeses(mes);
    }
  }, [meses]);

  useEffect(() => {
    obtenerCalendarioOperativo();
  }, []);

  return (
    <div className="mt-2">
      <Toast ref={toast} />
      <Loader loading={loading} querySelector={'#Inv'}/>

      <div className='d-flex flex-row'>
        <CalendarioOperativo
          dates={dates}
          setDates={setDates}
          loading={loading}
          getInfo={getInfo}
          tipo='mesoperativo'
        />

        <Button icon='pi pi-refresh' onClick={() => getInfo(month, year)} className='mx-2' loading={loading}/>
        <Button icon='pi pi-trash' onClick={() => eliminarTomas()} className='mx-2 p-button-danger' loading={loading}/>
        
        <span className="p-float-label">
          <Calendar value={fechaReporte} onChange={(e) => setFechaReporte(e.value)} style={{ height: 50, width: 150 }} showIcon showButtonBar />
          <label>Fecha Reporte</label>
        </span>
        <Button icon='ri-article-line' className="mx-2" onClick={() => setDialogReporte(true)} tooltip='Reporte' />
      </div>

      <div style={{ height: '78vh' }} className='pt-2' id='Inv'>
        <AgGrid table={tableHistorico} />
      </div>

      {
        dialogReporte && (
          <ReporteTomaInventario
            showReporte={dialogReporte}
            setShowReporte={setDialogReporte}
            fechaReporte={fechaReporte}
            setFechaReporte={setFechaReporte}
            IdTipoIngreso={IdTipoIngreso}
          />
        )
        
      }

    </div>
  );
};

export default TomaInventarioScreen;
